document.addEventListener("DOMContentLoaded", function () {
  const MAX_HEIGHT = 440; // Max visible height in pixels for .product_featured

  document.querySelectorAll(".product_featured").forEach((container) => {
    const viewMoreBtn = container
      .closest(".feature-row__text")
      ?.querySelector(".view_more_content");

    // Only proceed if there's a "Read More" button available
    if (!viewMoreBtn) return;

    // Clone the container to measure scroll height without affecting layout
    const clone = container.cloneNode(true);
    clone.style.position = "absolute";
    clone.style.visibility = "hidden";
    clone.style.height = "auto";
    clone.style.maxHeight = "none";
    document.body.appendChild(clone);

    const fullHeight = clone.scrollHeight;
    document.body.removeChild(clone);

    // If content is taller than allowed, truncate and show button
    if (fullHeight > MAX_HEIGHT) {
      container.style.maxHeight = MAX_HEIGHT + "px";
      container.classList.add("truncated");
      viewMoreBtn.style.display = "block";

      const plusIcon = viewMoreBtn.querySelector(".compplus");
      const minusIcon = viewMoreBtn.querySelector(".compminus");

      viewMoreBtn.addEventListener("click", function () {
        const isExpanded = container.classList.toggle("expanded");

        if (isExpanded) {
          container.style.maxHeight = "none";
          plusIcon.style.display = "none";
          minusIcon.style.display = "inline";
        } else {
          container.style.maxHeight = MAX_HEIGHT + "px";
          plusIcon.style.display = "inline";
          minusIcon.style.display = "none";
        }
      });
    }
  });
});
